/* ABC: кнопка «в корзину» — последовательность по словам владельца:

     1) нажатие — кнопка просто «вдавливается» по центру (scale), без
        движения вверх-вниз;
     2) Shopify подтвердил добавление — надпись на месте плавно сменяется
        на ADDED TO CART (не раньше: раньше тема ставила data-added сразу,
        ещё до ответа сервера);
     3) товар уже виден в шторке (перерисовалась, счётчик в заголовке
        сменился) и прошло не меньше 1.5с с появления ADDED TO CART —
        выезжает корзина. На медленном интернете шторка больше не
        открывается пустой.

   Салют с галочкой и полёт товара от Shopify выключены (CSS + настройка). */
(function () {
  var DONE_TEXT = 'ADDED TO CART';
  var BUSY_TEXT = 'ADDING…';
  var SHOW_BEFORE_CART_MS = 1500;   // сколько видна надпись до выезда корзины
  var LABEL_MS = 2200;              // сколько держим надпись, если корзина не выехала
  var lastBtn = null;

  /* надпись на кнопке — голая текстовая нода или .add-to-cart-text;
     оборачиваем один раз, добавляем вторую надпись */
  /* 27.09: без раннего выхода по data-abc-atc — при выборе размера тема
     перерисовывает содержимое кнопки (атрибут остаётся, надписи пропадают),
     поэтому каждый раз проверяем сами надписи; всё ниже повторно безопасно */
  function prepare(btn) {
    if (!btn) return btn;
    btn.dataset.abcAtc = '1';
    var wrapped = btn.querySelector('.add-to-cart-text');
    if (wrapped) wrapped.classList.add('abc-atc__label');
    [].slice.call(btn.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) {
        var s = document.createElement('span');
        s.className = 'abc-atc__label';
        s.textContent = n.textContent.trim();
        btn.replaceChild(s, n);
      }
    });
    /* 24.09: промежуточная надпись «ADDING…» с бегущей линией, пока ждём ответ Shopify */
    if (!btn.querySelector('.abc-atc__busy')) {
      var w = document.createElement('span');
      w.className = 'abc-atc__busy';
      w.setAttribute('aria-hidden', 'true');
      w.textContent = BUSY_TEXT;
      btn.appendChild(w);
    }
    if (!btn.querySelector('.abc-atc__done')) {
      var d = document.createElement('span');
      d.className = 'abc-atc__done';
      d.setAttribute('aria-hidden', 'true');
      d.textContent = DONE_TEXT;
      btn.appendChild(d);
    }
    return btn;
  }

  /* ADDED TO CART держим на форме, а не только на кнопке: тема во время
     добавления перерисовывает кнопку (цена, количество), новая кнопка теряла
     класс — поэтому анимация «не всегда отображалась». */
  function boot() {
    document.querySelectorAll('.add-to-cart-button, .quick-add__button').forEach(function (b) {
      prepare(b);
      var f = b.closest('product-form-component') || b.closest('form');
      if (f && f.dataset.abcAtcDone === '1' && !b.classList.contains('abc-atc--done')) b.classList.add('abc-atc--done');
      if (f && f.dataset.abcAtcBusy === '1' && !b.classList.contains('abc-atc--busy')) b.classList.add('abc-atc--busy');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });

  /* 1) нажатие — «вдавливание» */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, .quick-add__button');
    if (!btn || btn.disabled) return;
    prepare(btn);
    lastBtn = btn;
    lastForm = btn.closest('product-form-component') || btn.closest('form');
    /* нажатие кнопки без анимации — владелец отказался от «баунса»,
       остаётся только смена текста после подтверждения */
  }, true);

  var lastForm = null;
  var doneTimer = null;
  function liveBtn(btn) {
    if (btn && btn.isConnected) return btn;
    return lastForm && lastForm.isConnected
      ? lastForm.querySelector('.add-to-cart-button:not(.sticky-add-to-cart__button), .quick-add__button')
      : null;
  }
  function setBusy(btn, on) {
    if (lastForm) { if (on) lastForm.dataset.abcAtcBusy = '1'; else delete lastForm.dataset.abcAtcBusy; }
    btn = liveBtn(btn);
    if (btn) btn.classList.toggle('abc-atc--busy', !!on);
    if (!on) document.querySelectorAll('.abc-atc--busy').forEach(function (b) { b.classList.remove('abc-atc--busy'); });
  }
  function showDone(btn) {
    clearTimeout(doneTimer);
    setBusy(btn, false);
    if (lastForm) lastForm.dataset.abcAtcDone = '1';
    btn = liveBtn(btn);
    if (btn) btn.classList.add('abc-atc--done');
  }
  function hideDone(btn, delay) {
    clearTimeout(doneTimer);
    doneTimer = setTimeout(function () {
      if (lastForm) delete lastForm.dataset.abcAtcDone;
      btn = liveBtn(btn);
      if (btn) btn.classList.remove('abc-atc--done');
      document.querySelectorAll('.abc-atc--done').forEach(function (b) { b.classList.remove('abc-atc--done'); });
    }, delay || 0);
  }

  function openDrawer() {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer || typeof drawer.open !== 'function' || drawer.isOpen) return;
    try { drawer.open(); } catch (err) { /* тема могла пересобрать шторку */ }
  }
  function badgeText() {
    var b = document.querySelector('#cart-drawer .theme-drawer__badge');
    return b ? b.textContent.trim() : '';
  }
  /* ждём, пока шторка перерисуется с новым товаром (у темы это может быть
     отдельный запрос уже после ответа на добавление) */
  function whenDrawerUpdated(before, cb) {
    var done = false;
    var root = document.querySelector('#cart-drawer') || document.body;
    var finish = function () {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(guard);
      cb();
    };
    var obs = new MutationObserver(function () { if (badgeText() !== before) finish(); });
    obs.observe(root, { subtree: true, childList: true, characterData: true, attributes: true });
    var guard = setTimeout(finish, 8000);
    if (badgeText() !== before) finish();
  }

  /* 2) и 3): по событию темы о добавлении и его promise */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise) return;
    /* добавления не с кнопки товара (ARCHIVE LOOK, «вернуть» в корзине) — не наши */
    if (!(e.target instanceof Element) || !lastForm || !(e.target === lastForm || lastForm.contains(e.target) || e.target.contains(lastForm))) return;
    var btn = lastBtn;
    var before = badgeText();
    setBusy(btn, true);
    e.promise.then(function (res) {
      if (res && res.detail && res.detail.didError) { setBusy(btn, false); return; }
      var tShown = Date.now();
      showDone(btn);
      if (/^\/cart\/?$/.test(location.pathname)) { hideDone(btn, LABEL_MS); return; }
      whenDrawerUpdated(before, function () {
        var wait = Math.max(0, SHOW_BEFORE_CART_MS - (Date.now() - tShown));
        setTimeout(function () {
          openDrawer();
          hideDone(btn, 400);   // надпись уходит, когда корзина уже выехала
        }, wait);
      });
    }).catch(function () { setBusy(btn, false); /* добавление отменено или ошибка */ });
  });
})();

